<template>
    <!-- TODO : Refactoring : use feed-modification.vue and modal-extend-feed.vue -->
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        <ns-loader
            v-if="feed !== null"
            ref="nsLoader"
            :to-load="toLoad"
            :fetch-timer="null"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-form
                slot="content"
                ref="form"
                :model="form"
                :rules="rules"
                class="modal-confirm-feed"
            >
                <div
                    class="gcmcn-inputs-container"
                    v-if="feedIsInternalSource"
                >
                    <div class="flex-basis-6">
                        <el-form-item class="gcmcn-form-input">
                            <div class="gcmcn-form-label">Booking type</div>
                            <el-switch
                                v-model="isAutomaticBooking"
                                active-text="Automatic"
                                inactive-text="Manual"
                                @change="$refs.form.clearValidate();"
                            >
                            </el-switch>
                        </el-form-item>
                    </div>
                </div>
                <template v-if="feedIsInternalSource && isAutomaticBooking">
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="booking_ip_main">

                                <div class="gcmcn-form-label type-input-spacing">Main source</div>
                                <el-select
                                    v-model="form.booking_ip_main"
                                    placeholder="Globecast region MAIN"
                                    class="gcmcn-form-label"
                                    popper-class="gcmcn-popper"
                                    filterable
                                    @visible-change="mainSourceIsBlurred = !mainSourceIsBlurred"
                                >
                                    <template
                                        v-if="selectedMainIp && mainSourceIsBlurred"
                                        slot="prefix"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{selectedMainIp.name}}</span>
                                            <span class="ip-details">{{selectedMainIp.protocol.toLowerCase()}}://{{selectedMainIp.multicast_ip}}:{{selectedMainIp.port}}@{{selectedMainIp.source_ip}}</span>
                                        </div>
                                    </template>
                                    <el-option
                                        v-for="ip in mainIpsOptions"
                                        :key="ip.uid"
                                        :label="`${ip.name}  --  ${ip.protocol.toLowerCase()}://${ip.multicast_ip}:${ip.port}@${ip.source_ip}`"
                                        :value="ip.uid"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{ip.name}}</span>
                                            <span class="ip-details">{{ip.protocol.toLowerCase()}}://{{ip.multicast_ip}}:{{ip.port}}@{{ip.source_ip}}</span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="booking_ip_backup">

                                <div class="gcmcn-form-label type-input-spacing">Backup source</div>
                                <el-select
                                    v-model="form.booking_ip_backup"
                                    placeholder="Globecast region BACKUP"
                                    class="gcmcn-form-label"
                                    popper-class="gcmcn-popper"
                                    filterable
                                    @visible-change="backupSourceIsBlurred = !backupSourceIsBlurred"
                                >
                                    <template
                                        v-if="selectedBackupIp && backupSourceIsBlurred"
                                        slot="prefix"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{selectedBackupIp.name}}</span>
                                            <span class="ip-details">{{selectedBackupIp.protocol.toLowerCase()}}://{{selectedBackupIp.multicast_ip}}:{{selectedBackupIp.port}}@{{selectedBackupIp.source_ip}}</span>
                                        </div>
                                    </template>
                                    <el-option
                                        v-for="ip in backupIpsOptions"
                                        :key="ip.uid"
                                        :label="`${ip.name}  --  ${ip.protocol.toLowerCase()}://${ip.multicast_ip}:${ip.port}@${ip.source_ip}`"
                                        :value="ip.uid"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{ip.name}}</span>
                                            <span class="ip-details">{{ip.protocol.toLowerCase()}}://{{ip.multicast_ip}}:{{ip.port}}@{{ip.source_ip}}</span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <template v-else-if="feedIsInternalSource">
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_main">
                                <div class="gcmcn-form-label">Main multicast ip</div>
                                <el-input
                                    v-model="form.multicast_network_ip_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_backup">
                                <div class="gcmcn-form-label">Backup multicast ip</div>
                                <el-input
                                    v-model="form.multicast_network_ip_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_src_main">
                                <div class="gcmcn-form-label">Main source ip</div>
                                <el-input
                                    v-model="form.multicast_network_src_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_src_backup">
                                <div class="gcmcn-form-label">Backup source ip</div>
                                <el-input
                                    v-model="form.multicast_network_src_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="port_main">
                                <div class="gcmcn-form-label">Main port</div>
                                <el-input
                                    v-model.number="form.port_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="port_backup">
                                <div class="gcmcn-form-label">Backup port</div>
                                <el-input
                                    v-model.number="form.port_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="type">

                                <div class="gcmcn-form-label type-input-spacing">Type</div>
                                <el-select
                                    v-model="form.type"
                                    placeholder="UDP"
                                    class="gcmcn-form-label"
                                >
                                    <div class="gcmcn-form-label options-type"></div>
                                    <el-option
                                        v-for="item in options"
                                        :key="item.type"
                                        :label="item.label"
                                        :value="item.type"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="booking_key">
                            <div class="gcmcn-form-label">Work Order</div>
                            <el-input
                                size="mini"
                                v-model="booking_key"
                                maxlenght="15"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="" style="margin-right: 15px; flex-grow: 1;">
                        <el-form-item class="gcmcn-form-input" prop="confirmed_start_date">
                            <div class="gcmcn-form-label">Confirmed start date</div>
                            <el-date-picker
                                v-model="form.confirmed_start_date"
                                popper-class="gcmcn-popper"
                                type="date"
                                size="mini"
                                placeholder="Select a date"
                                @change="handleStartDateChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item class="gcmcn-form-input" prop="confirmed_start_time">
                            <div class="gcmcn-form-label">At</div>
                            <ns-time-picker
                                v-model="form.confirmed_start_time"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="" style="margin-right: 15px; flex-grow: 1;">
                        <el-form-item class="gcmcn-form-input" prop="confirmed_end_date">
                            <div class="gcmcn-form-label">Confirmed end date</div>
                            <el-date-picker
                                v-model="form.confirmed_end_date"
                                popper-class="gcmcn-popper"
                                type="date"
                                size="mini"
                                placeholder="Select a date"
                                :pickerOptions="pickerOptions"
                                @change="handleEndDateChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item class="gcmcn-form-input" prop="confirmed_end_time">
                            <div class="gcmcn-form-label">At</div>
                            <ns-time-picker
                                v-model="form.confirmed_end_time"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div
                    v-if="(userIsAtLeastAdmin || userIsEntityAdmin(entityUid)) && this.feedIsInternalSource"
                    class="gcmcn-inputs-container"
                >
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="datacenter_obj_uid">
                            <div class="gcmcn-form-label type-input-spacing">Globecast region</div>
                            <el-select
                                v-model="form.datacenter_obj_uid"
                                class="gcmcn-form-label"
                                @change="resetBookingIp"
                            >
                                <el-option
                                    v-for="datacenter in datacenters"
                                    :key="datacenter.uid"
                                    :label="datacenter.name"
                                    :value="datacenter.uid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-alert
                    type="warning"
                    effect="dark"
                    :closable="false"
                >
                    <p style="font-weight: bolder; word-break: break-word">Do you really want to confirm this feed ?<br>
                    Please check carefully the data provided and confirm the action by typing "CONFIRM"</p>
                    <el-form-item class="gcmcn-form-input" style="margin-top: 15px;" prop="passPhrase">
                        <el-input v-model="form.passPhrase" placeholder="Enter confirm"></el-input>
                    </el-form-item>
                </el-alert>
            </el-form>
        </ns-loader>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="confirmFeed"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import NsTimePicker from 'fundation-app-vuejs/src/components/partials/ns-time-picker.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        DefaultModal,
        NsTimePicker,
        NsLoader,
        LoadingTemplate,
    },

    props: {

    },

    data (){
        return {
            showModal: false,
            isAutomaticBooking: false,
            mainIps: [],
            backupIps: [],
            datacenters: [],
            form: {
                multicast_network_ip_main: '',
                multicast_network_src_main: '',
                multicast_network_ip_backup: '',
                multicast_network_src_backup: '',
                datacenter_obj_uid: '',
                port_main: 0,
                port_backup: 0,
                confirmed_start_date: '',
                confirmed_start_time: '',
                confirmed_end_date: '',
                confirmed_end_time: '',
                booking_ip_main: null,
                booking_ip_backup: null,
                passPhrase: '',
                type: 'RTP',
            },
            options: [{
                type: 'UDP',
                label: 'UDP'
            },
            {
                type: 'RTP',
                label: 'RTP'
            }],
            loading: false,
            feed: null,
            event: null,
            videoSource: null,
            booking_key: '',
            mainSourceIsBlurred: true,
            backupSourceIsBlurred: true,
            universe: null,
        };
    },
    computed: {
        ...mapGetters([
            'entitiesByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'groups',
        ]),
        entityUid(){
            if(this.feed){
                return this.feed.scopes.entity_uid;
            }
            return null;
        },
        selectedMainIp(){
            if(this.form.booking_ip_main){
                return this.mainIps.find(ip => ip.uid === this.form.booking_ip_main);
            }
            return null;
        },
        selectedBackupIp(){
            if(this.form.booking_ip_backup){
                return this.backupIps.find(ip => ip.uid === this.form.booking_ip_backup);
            }
            return null;
        },
        toLoad (){
            let modelTofetch = [];
            if(this.feed && this.feedIsInternalSource && this.datacenterUid){
                modelTofetch.push({
                    model: 'ips',
                    name: 'ips',
                    filters:{
                        datacenter_uid: this.datacenterUid,
                        archived: false,
                        ordering: 'name',
                    }
                });
            }
            if(this.feed && this.feed.confirmed && this.feedIsInternalSource){
                modelTofetch.push({
                    model: 'videoSources',
                    name: 'videoSource',
                    uid: this.feed.video_source_uid,
                });
            }
            return [
                {
                    model: 'datacenters',
                    name: 'datacenters',
                    filters:{
                        archived: false
                    }
                },
                ...modelTofetch
            ];
        },
        rules (){
            let rules = {
                confirmed_start_date: [{required: true}],
                confirmed_start_time: [{validator: this.validStartTime, required: true}],
                confirmed_end_date: [{validator: this.validEndDate}],
                confirmed_end_time: [{validator: this.validEndTime, required: true}],
                passPhrase: [{ validator: this.checkConfirm, required: true}],
                booking_key: [{validator: this.workOrderRule}]
            };
            if(this.isAutomaticBooking){
                rules = Object.assign(rules, {
                    booking_ip_main: [{required: true, message: 'Globecast region MAIN is required.'}],
                    booking_ip_backup: [{ required: true, message: 'Globecast region BACKUP is required.'}],
                });
            }else if(this.feedIsInternalSource){
                rules = Object.assign(rules, {
                    type: [{ type: 'string', required: true}],
                    multicast_network_ip_main: [{validator: this.checkIp, required: true}],
                    multicast_network_src_main: [{validator: this.checkIp, required: true}],
                    multicast_network_ip_backup: [{validator: this.checkIp, required: true}],
                    multicast_network_src_backup: [{validator: this.checkIp, required: true}],
                    port_main: [{type: 'number', required: true}],
                    port_backup: [{type: 'number', required: true}],
                });
            }

            return rules;
        },
        feedIsInternalSource (){
            return this.feed.source_type === 'internal';
        },
        datacenterUid(){
            if(this.entitiesByUid(this.feed.scopes.entity_uid).datacenter_uid){
                return this.entitiesByUid(this.feed.scopes.entity_uid).datacenter_uid;
            }
            return null;
        },
        mainIpsOptions(){
            return this.mainIps.filter(ip => ip.datacenter === this.form.datacenter_obj_uid);
        },
        backupIpsOptions(){
            return this.backupIps.filter(ip => ip.datacenter === this.form.datacenter_obj_uid);
        },
        pickerOptions (){
            return {
                disabledDate: (time) => {
                    // We use new Date with moment because we need to handle utc date with moment and el-date-picker only handle Date objects
                    let startDate = moment(this.form.confirmed_start_date).format('YYYY-MM-DD');
                    return time.getTime() < new Date(moment(startDate).utc());
                },
            };
        },
    },
    mounted (){
    },

    methods: {
        handleStartDateChange(date){
            this.$set(this.form, 'confirmed_start_date', new Date(moment(date).format('YYYY-MM-DD')));
        },
        handleEndDateChange(date){
            this.$set(this.form, 'confirmed_end_date', new Date(moment(date).format('YYYY-MM-DD')));
        },
        resetBookingIp(){
            this.$set(this.form, 'booking_ip_main', '');
            this.$set(this.form, 'booking_ip_backup', '');
        },
        checkIp (rule, value, callback) {
            if(!value){
                return callback(new Error('This field can\'t be empty'));
            }else if(!value.match(this.$store.getters.regexIp)){
                return callback(new Error('This field must be a valid ip'));
            }
            callback();
        },
        validStartTime (rule, value, callback) {
            let times = this.form.confirmed_start_time.split(':');
            // l'heure que l'utilisateur rentre doit être en utc (pas en local)
            // si je fait un moment.utc(this.form.confirmed_start_date) j'obtiens YYYY-MM-DD moins 1 jour 23h00:00
            // vue que la date récupérer est au format YYYY-MM-DDT00:00:00Z il applique le décalage sur l'heure et me
            // retourne le jour précédent à 23H (avec ma timezone)
            // workaround pour éviter qu'il applique le dacalage horraire
            let date = new moment.utc(moment(this.form.confirmed_start_date).format('YYYY-MM-DD'), 'YYYY-MM-DD');
            if(!this.form.confirmed_start_time){
                return callback(new Error('Start time is required'));
            }else if(!this.form.confirmed_start_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('Start time format must match HH:mm pattern'));
            }else{
                date.set({hours: times[0], minutes: times[1], seconds: 0});
                if(date.diff(moment.utc(), 'minutes') < 0){
                    return callback(new Error('Start date with start time must be in future'));
                }
                callback();
            }
        },
        validEndDate (rule, value, callback) {
            if(!this.form.confirmed_end_date){
                return callback(new Error('End date is required'));
            }
            let startDateIsBefore = new Date(this.form.confirmed_start_date).getTime() <= new Date(this.form.confirmed_end_date).getTime();
            if(!startDateIsBefore){
                return callback(new Error('End date must be after start date'));
            }
            callback();
        },
        validEndTime (rule, value, callback) {
            if(!this.form.confirmed_end_time){
                return callback(new Error('End time is required'));
            }else if(!this.form.confirmed_end_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('End time format must match HH:mm pattern'));
            }
            let timeStartInt = parseInt(this.form.confirmed_start_time.replace(/\:/g, ''));
            let timeEndInt = parseInt(this.form.confirmed_end_time.replace(/\:/g, ''));
            let startTimeIsBefore = new Date(this.form.confirmed_start_date) < new Date(this.form.confirmed_end_date);
            if(!startTimeIsBefore && this.form.confirmed_start_time !== '' && timeStartInt >= timeEndInt){
                return callback(new Error('End time musn\'t be before start time'));
            }
            callback();
        },

        checkConfirm (rule, value, callback) {
            if(!value){
                return callback(new Error('Pass phrase is required'));
            }else if(value !== 'CONFIRM'){
                return callback(new Error('Pass phrase must be equal to CONFIRM in uppercase.'));
            }
            callback();
        },
        workOrderRule (rule, value, callback) {
            if(this.booking_key.length > 15) {
                return callback(new Error('The work order must be less than 15 characters'));
            }
            callback();
        },
        onDataFetched (res){
            this.$set(this, 'datacenters', res.datacenters);
            if(res.ips){
                let mainIps = res.ips.filter(ip => ip.ip_type === 'main');
                let backupIps = res.ips.filter(ip => ip.ip_type === 'backup');
                this.$set(this,'mainIps',mainIps);
                this.$set(this,'backupIps',backupIps);
                if(!this.feed.confirmed){
                    this.isAutomaticBooking = true;
                }
            }
            if(res.videoSource){
                this.$set(this, 'videoSource', res.videoSource);
                if(this.feed.booking_type === 'manual'){
                    this.form.multicast_network_ip_main = this.videoSource.multicast_network_ip_main;
                    this.form.multicast_network_src_main = this.videoSource.multicast_network_src_main;
                    this.form.multicast_network_ip_backup = this.videoSource.multicast_network_ip_backup;
                    this.form.multicast_network_src_backup = this.videoSource.multicast_network_src_backup;
                    this.form.port_main = parseInt(this.videoSource.port_main);
                    this.form.port_backup = parseInt(this.videoSource.port_backup);
                    this.form.type = this.videoSource.type;
                    this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                } else {
                    this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                }
            } else {
                let datacenterDefaultValue = this.datacenters.find((datacenter) => datacenter.is_default === true);
                let datacenterEntityDefaultValue = this.entitiesByUid(this.feed.scopes.entity_uid).datacenter;

                if(datacenterEntityDefaultValue){
                    this.$set(this.form, 'datacenter_obj_uid', datacenterEntityDefaultValue);
                } else {
                    if(datacenterDefaultValue){
                        this.$set(this.form, 'datacenter_obj_uid', datacenterDefaultValue.uid);
                    }
                }
            }
        },
        open (feed, event, universe){
            this.$set(this, 'feed', feed);
            this.$set(this, 'event', event);
            this.$set(this, 'universe', universe);
            if(!this.feed.confirmed){
                this.setBookingDefaultDateTime();
            }else{
                this.setBookingConfirmedDateTime();
                if(this.feed.booking_type === 'automatic'){
                    this.$set(this.form, 'booking_ip_main', this.feed.booking_ip_main_uid);
                    this.$set(this.form, 'booking_ip_backup', this.feed.booking_ip_backup_uid);
                    this.isAutomaticBooking= true;
                }
            }
            this.showModal = true;
        },
        closeModal (){
            this.resetFields();
            this.$set(this, 'feed', null);
            this.$set(this, 'event', null);
            this.isAutomaticBooking = false;
            this.showModal = false;
        },
        resetFields(){
            this.form = {
                multicast_network_ip_main: '',
                multicast_network_src_main: '',
                multicast_network_ip_backup: '',
                multicast_network_src_backup: '',
                port_main: 0,
                port_backup: 0,
                confirmed_start_date: '',
                confirmed_start_time: '',
                confirmed_end_date: '',
                confirmed_end_time: '',
                booking_ip_main: null,
                booking_ip_backup: null,
                passPhrase: '',
                type: 'RTP',
            };
        },
        setBookingDefaultDateTime(){
            // We use new Date with moment because we need to handle utc date with moment and el-date-picker only handle Date objects
            this.$set(
                this.form,
                'confirmed_start_time',
                moment
                .utc(this.feed.start_date)
                .format('HH:mm')
            );
            this.$set(
                this.form,
                'confirmed_end_time',
                moment
                .utc(this.feed.end_date)
                .format('HH:mm')
            );
            this.$set(
                this.form,
                'confirmed_start_date',
                new Date(moment(this.feed.start_date)
                .utc().format('YYYY-MM-DD')
            ));
            this.$set(
                this.form,
                'confirmed_end_date',
                new Date(moment(this.feed.end_date)
                .utc().format('YYYY-MM-DD')
            ));
        },
        setBookingConfirmedDateTime(){
            // form.end_date is never posted
            this.$set(this.form, 'end_date', this.form.confirmed_end_date);
            this.$set(
                this.form,
                'confirmed_start_time',
                moment
                .utc(this.feed.confirmed_start_date)
                .format('HH:mm')
            );
            this.$set(
                this.form,
                'confirmed_end_time',
                moment
                .utc(this.feed.confirmed_end_date)
                .format('HH:mm')
            );
            this.$set(
                this.form,
                'confirmed_start_date',
                new Date(moment(this.feed.confirmed_start_date)
                .utc().format('YYYY-MM-DD')
            ));
            this.$set(
                this.form,
                'confirmed_end_date',
                new Date(moment(this.feed.confirmed_end_date)
                .utc().format('YYYY-MM-DD')
            ));
            // console.log('start_date', this.form.confirmed_end_date)
        },
        confirmFeed (){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.loading = true;
                let videoSourceResponse = null;
                let form = JSON.parse(JSON.stringify(this.form));
                form.confirmed_start_time = moment.utc(this.form.confirmed_start_time, 'HH:mm:ss').format('HH:mm:ss');
                form.confirmed_end_time = moment.utc(this.form.confirmed_end_time, 'HH:mm:ss').format('HH:mm:ss');
                if(this.feedIsInternalSource){
                    if(this.isAutomaticBooking){
                        let mainIp = this.mainIps.find(ip => ip.uid === form.booking_ip_main);
                        let backupIp = this.backupIps.find(ip => ip.uid === form.booking_ip_backup);
                        form.multicast_network_ip_main = mainIp.multicast_ip;
                        form.multicast_network_src_main = mainIp.source_ip;
                        form.multicast_network_ip_backup = backupIp.multicast_ip;
                        form.multicast_network_src_backup = backupIp.source_ip;
                        form.port_main = parseInt(mainIp.port);
                        form.port_backup = parseInt(backupIp.port);
                        /*
                            Right now main and backup Ips will always have the same protocol.
                            If at some point the case where both can be different exist
                            it'll be handled by the backend and front will return UDP by default.
                        */
                        form.type = mainIp.protocol !== backupIp.protocol?'UDP':mainIp.protocol;
                    }

                    let videoSource = Object.assign({}, form);
                    let data = {
                        item: videoSource,
                        model: 'videoSources',
                    };
                    let action = 'createItem';

                    if(this.videoSource){
                        action = 'patchItem';
                        data.item.url = this.videoSource.url;
                    }else{
                        data.item.name = `${ this.event.name } - ${ this.feed.name }`;
                        data.scopes = {'X-Entity-Uid': this.entityUid};
                        data.url = this.$store.state.api.meta.listModels.videoSources.url;
                    }

                    videoSourceResponse = await this.$store.dispatch(action, data)
                    .catch((e) => {
                        console.error(e);
                        this.$notify({
                            type: 'error',
                            title: `Error on feed ${this.feed.display_name} confirmation`
                        });
                        this.loading = false;
                        return;
                    });
                }

                let startTimeSplitted = form.confirmed_start_time.split(':');
                let endTimeSplitted = form.confirmed_end_time.split(':');
                form.confirmed_start_date = moment(form.confirmed_start_date).set({
                    hours: startTimeSplitted[0],
                    minutes: startTimeSplitted[1],
                    seconds: startTimeSplitted[2],
                }).format('YYYY-MM-DDTHH:mm:ss');
                form.confirmed_end_date = moment(form.confirmed_end_date).set({
                    hours: endTimeSplitted[0],
                    minutes: endTimeSplitted[1],
                    seconds: endTimeSplitted[2],
                }).format('YYYY-MM-DDTHH:mm:ss');
                let item = {
                    confirmed_start_date: form.confirmed_start_date,
                    confirmed_end_date: form.confirmed_end_date,
                    confirmed: true,
                    url: this.feed.url,
                    booking_key: this.booking_key,
                };
                if(this.isAutomaticBooking){
                    item.booking_type = 'automatic';
                    item.booking_ip_main_uid = form.booking_ip_main;
                    item.booking_ip_backup_uid = form.booking_ip_backup;
                }else{
                    item.booking_type = 'manual';
                }
                if(this.feedIsInternalSource && videoSourceResponse){
                    item.video_source_uid = videoSourceResponse.uid;
                }
                this.$store.dispatch('patchItem', {
                    item: item,
                    model: 'feeds',
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Feed ${this.feed.display_name} confirmed`
                    });
                    this.$emit('on-trigger-refresh');
                    this.closeModal();
                }).catch((e) => {
                    console.error(e);
                    this.$notify({
                        type: 'error',
                        title: `Error on feed ${this.feed.display_name} confirmation`
                    });
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
    },
};
</script>

<style lang="scss">
.modal-confirm-feed{
    .el-input.digital{
        /*
            This width is defined in ns-time-picker (fundation).
            I have to use !important since adding :not(.digital) is not working
            at line 487
        */
        width: 50px !important;
    }
    .gcmcn-form-label.el-select{
        .el-input{
            &__prefix{
                width: 550px;
                padding: 13px 25px;
                background-color: #444;
                color: #fff;
            }
        }
    }
    .el-input:not(.hours):not(.minutes):not(.seconds):not(.digital-clock){
        width: 100%;
    }
    .el-alert{
        .el-form-item__error{
            color: #ff1100;
        }
    }
    .options-type {
        padding-bottom: 0.5em;
    }
}
.type-input-spacing{
    padding-bottom: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/modal-confirm-feed.vue